import { AsyncPipe } from '@angular/common';
import { AfterContentInit, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { IconButtonComponent } from '../../button';
import { FilterMenuComponent } from '../filter-menu.component';

@Component({
  selector: 'app-online-filter-menu',
  templateUrl: './online-filter-menu.component.html',
  styleUrls: ['./online-filter-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe, MatIconModule, IconButtonComponent, RouterLink],
})
export class OnlineFilterMenuComponent extends FilterMenuComponent implements OnInit, AfterContentInit {
  constructor() {
    super();
  }
}
